import SrAlert from "./SrAlert.vue";

SrAlert.install = function(Vue) {
  Vue.component(SrAlert.name, SrAlert);
};

export default SrAlert;


// WEBPACK FOOTER //
// ./packages/SrAlert/index.js